import React, { useState, useEffect } from "react";
import ProfileHeader from "../../Components/profile/ProfileHeader";
import TabNavigation from "../../Components/tabs/TabNavigation";
import VideoCard from "../../Components/cards/VideoCard";
import ReelCard from "../../Components/cards/ReelCard";
import Header from "../../Components/Header/Header";
import { callApi } from "../../utils/apiService";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { useUser } from "../../Context/UserContext";
import PaginationLeft from "../../assets/images/pagination-left-arrow.svg";
import PaginationRight from "../../assets/images/pagination-right-arrow.svg";
import dayjs from "dayjs";
const ContentPage = () => {
  const [activeTab, setActiveTab] = useState("Videos");

  const ITEMS_PER_PAGE = 10;

  const [contentData, setContentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  const { user } = useUser();

  const fetchContent = async () => {
    if (!user?.id) return;

    try {
      setLoading(true);

      let endpoint = "";

      switch (activeTab) {
        case "Videos":
          endpoint = `creatorData/${user.id}/videos?page=${currentPage}&limit=${ITEMS_PER_PAGE}`;
          break;

        case "Reels":
          endpoint = `creatorData/${user.id}/reels?page=${currentPage}&limit=${ITEMS_PER_PAGE}`;
          break;

        case "Stories":
          endpoint = `creatorData/${user.id}/stories?page=${currentPage}&limit=${ITEMS_PER_PAGE}`;
          break;

        default:
          return;
      }

      const response = await callApi(
        `${videoCreatorEndPoint}${endpoint}`,
        "GET",
      );

      if (response?.status) {
        const data = response.data;

        if (activeTab === "Videos") {
          setContentData(data?.videos || []);
          setTotalItems(data?.pagination?.totalVideos || 0);
        }

        if (activeTab === "Reels") {
          setContentData(data?.reels || []);
          setTotalItems(data?.pagination?.totalReels || 0);
        }

        if (activeTab === "Stories") {
          setContentData(data?.stories || []);
          setTotalItems(data?.pagination?.totalStories || 0);
        }

        setTotalPages(data?.pagination?.totalPages || 0);
      }
    } catch (error) {
      console.error(`${activeTab} API Error:`, error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [user?.id, activeTab, currentPage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  const showingFrom =
    totalItems === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1;

  const showingTo = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1,
  );

  return (
    <div>
      <Header />

      <div className=" flex justify-center bg-[#f4f7fe] min-h-screen">
        <div className="bg-white max-w-[1100px] shadow-sm mb-24 border-l border-r border-[#eef1f8]">
          <ProfileHeader />

          <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} />

          <div className="w-full mt-4 pb-4">
            {activeTab === "Videos" && (
              <div className="flex flex-col">
                {contentData.map((video) => (
                  <VideoCard
                    key={video.id}
                    id={video.id}
                    title={video.title}
                    time={dayjs(video.publishedAt).format(
                      "DD MMM YYYY, hh:mm A",
                    )}
                    likes={video.likesCount}
                    views={video.viewsCount}
                    shares={video.shareCount}
                    saves={video.favoritesCount}
                    comments={video.commentsCount}
                    thumbnail={video.thumbnailImage || video.generatedThumbnail}
                    videoUrl={video.videoUrl}
                    item={video}
                    contentType="Video"
                  />
                ))}
              </div>
            )}

            {activeTab === "Reels" && (
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 px-8 mt-6">
                {contentData.map((reel) => (
                  <ReelCard
                    key={reel.id}
                    title={reel.title || reel.caption}
                    likes={reel.likesCount}
                    views={reel.viewsCount}
                    shares={reel.shareCount}
                    saves={reel.favoritesCount}
                    thumbnail={reel.thumbnailImage || reel.generatedThumbnail}
                    item={reel}
                    contentType="Reel"
                  />
                ))}
              </div>
            )}

            {activeTab === "Stories" && (
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 px-8 mt-6">
                {contentData.map((story) => (
                  <ReelCard
                    key={story.id}
                    title={story.title || story.caption}
                    likes={story.likesCount}
                    views={story.viewsCount}
                    shares={story.shareCount}
                    thumbnail={story.thumbnailImage || story.storyUrl}
                    item={story}
                    contentType="Story"
                    isStory
                  />
                ))}
              </div>
            )}
          </div>
          {contentData.length > 0 && (
            <div className="pagination-wrapper">
              <span className="content-pagination-info">
                Showing
                <span className="content-pagination-count">
                  {" "}
                  {showingFrom}-{showingTo}
                </span>{" "}
                from
                <span className="content-pagination-count">
                  {" "}
                  {totalItems}
                </span>{" "}
                data
              </span>

              <div className="pagination-controls">
                <img
                  src={PaginationLeft}
                  alt="Previous"
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor: currentPage > 1 ? "pointer" : "not-allowed",
                    opacity: currentPage > 1 ? 1 : 0.5,
                  }}
                  onClick={() =>
                    currentPage > 1 && setCurrentPage((prev) => prev - 1)
                  }
                />

                {pageNumbers.map((page) => (
                  <button
                    key={page}
                    className={`content-pagination-btn page-btn ${
                      currentPage === page ? "active" : ""
                    }`}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}

                <img
                  src={PaginationRight}
                  alt="Next"
                  style={{
                    width: "32px",
                    height: "32px",
                    cursor:
                      currentPage < totalPages ? "pointer" : "not-allowed",
                    opacity: currentPage < totalPages ? 1 : 0.5,
                  }}
                  onClick={() =>
                    currentPage < totalPages &&
                    setCurrentPage((prev) => prev + 1)
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentPage;
